import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DbSignUpOptions, WebAuth } from 'auth0-js';

@Component({
  selector: 'app-auth0-sdk-login',
  templateUrl: './auth0-sdk-login.component.html',
  styleUrls: ['./auth0-sdk-login.component.css'],
})
export class Auth0SdkLoginComponent implements OnChanges {
  @Input()
  clientID;

  @Input()
  domain;
  auth0: WebAuth;

  constructor() {}

  ngOnChanges() {
    this.auth0 = new WebAuth({
      clientID: this.clientID,
      domain: this.domain,
    });
  }

  login() {}

  signup() {
    type option = DbSignUpOptions & {
      given_name: string;
      family_name: string;
      phone_number: string;
      name: string;
    };
    const name = `welcome1`;
    const o: option = {
      connection: 'Username-Password-Authentication',
      email: `osaki.shin+${name}@andgate.co.jp`,
      password: 'qweQWE123',
      username: name,
      given_name: 'taro',
      family_name: 'yamada',
      name: `yamada taro`,
      phone_number: '0120-00-0000',
    };

    // auth.signup(o, (e, r) => {
    //   console.log(e, r);
    // });
  }
}
